import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { TaskService, UserService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class TaskOperatorGuard implements CanActivate {

  constructor(
    private router: Router,
    private taskService: TaskService,
    private userService: UserService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    try {
      // 獲取路由參數中的 taskId
      const taskId = route.params['taskId'];
      if (!taskId) {
        console.error('TaskOperatorGuard: taskId not found in route params');
        await this.router.navigate(['/error']);
        return false;
      }

      // 獲取當前用戶 ID
      const currentUserId = await this.userService.getUserId();
      if (!currentUserId) {
        console.error('TaskOperatorGuard: Current user not found');
        await this.router.navigate(['/login']);
        return false;
      }

      // 獲取任務詳情
      const taskResponse = await this.taskService.getTaskById(taskId);
      if (!taskResponse || !taskResponse.data || taskResponse.data.length === 0) {
        console.error('TaskOperatorGuard: Task not found');
        await this.router.navigate(['/error']);
        return false;
      }

      const task = taskResponse.data[0];

      // 檢查當前用戶是否為任務創建者或接受者
      const isCreator = task.creatorId === currentUserId;
      const isAcceptor = task.acceptorId === currentUserId && task.isAccepted;

      if (isCreator || isAcceptor) {
        return true;
      } else {
        // 如果不是創建者或接受者，重導向到一般的任務詳情頁面
        console.warn('TaskOperatorGuard: User is not creator or acceptor, redirecting to general task detail');
        await this.router.navigate(['/task-detail', taskId], {
          queryParams: route.queryParams
        });
        return false;
      }

    } catch (error) {
      console.error('TaskOperatorGuard: Error checking permissions', error);
      await this.router.navigate(['/error']);
      return false;
    }
  }
}
